import { render, staticRenderFns } from "./OaoTitle.vue?vue&type=template&id=8e19be74&scoped=true&functional=true"
import script from "./OaoTitle.vue?vue&type=script&lang=js"
export * from "./OaoTitle.vue?vue&type=script&lang=js"
import style0 from "./OaoTitle.vue?vue&type=style&index=0&id=8e19be74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "8e19be74",
  null
  
)

export default component.exports